import SeoPageLayout from "@/components/SeoPageLayout";

const WystepKabaretowyRzeszow = () => (
  <SeoPageLayout title="Występ kabaretowy Rzeszów - śmiech gwarantowany">
    <p>
      Rzeszów dynamicznie się rozwija i przyciąga coraz więcej firm z sektora nowoczesnych technologii. Występ kabaretowy w Rzeszowie to doskonała atrakcja na firmowe wydarzenia - od konferencji branżowych po imprezy integracyjne w Dolinie Lotniczej.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Kabaret na eventy firmowe w Rzeszowie</h2>
    <p>
      Realizujemy występy kabaretowe w całym Rzeszowie i okolicach. Występujemy w nowoczesnych hotelach, centrach konferencyjnych oraz eleganckich restauracjach. Program dopasowujemy do specyfiki branży - od IT i lotnictwa po sektor usług.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Lokalizacje na występy w Rzeszowie</h2>
    <ul className="list-disc pl-6 space-y-2">
      <li>Hotele w centrum - komfortowe warunki na gale i bankiety</li>
      <li>Centra konferencyjne - idealne na duże eventy korporacyjne</li>
      <li>Restauracje nad Wisłokiem - klimatyczne spotkania firmowe</li>
      <li>Obiekty w okolicach - eventy integracyjne na Podkarpaciu</li>
    </ul>

    <h2 className="text-2xl font-bold text-foreground mt-10">Dlaczego kabaret w Rzeszowie?</h2>
    <p>
      Rzeszów to miasto ludzi ambitnych i pracowitych. Nasz kabaret docenia tę energię i przekuwa ją w humor, który bawi i integruje. Każdy występ to indywidualnie przygotowany program, który trafia w gusta rzeszowskiej publiczności biznesowej.
    </p>
  </SeoPageLayout>
);

export default WystepKabaretowyRzeszow;
